import { useCookie, useLogError } from '@wkda/funnel-components';
import { trackReturningUserEvent } from '@wkda/time-tracking';
import { useEffect } from 'react';
import { useCarleadConfiguration } from './useCarleadCreationConfiguration';
export const isRobot = () => {
  const pattern = /bot|googlebot|crawler|spider|robot|crawling/i;
  return !!navigator.userAgent.match(pattern);
};
export function useTimeTracking(_ref) {
  let {
    page,
    carleadHash,
    pageType
  } = _ref;
  const isReturningUser = !!carleadHash;
  const hostName = typeof window === 'object' ? window.location.hostname : '';
  const {
    stepsTimeTracking
  } = useCarleadConfiguration();
  const isEnabled = stepsTimeTracking.isEnabledFor.includes(page);
  const logError = useLogError();
  useEffect(() => {
    if (isEnabled && isReturningUser && !isRobot()) {
      try {
        trackReturningUserEvent({
          hostUrl: hostName,
          hash: carleadHash,
          page: pageType,
          options: stepsTimeTracking.options,
          returningUser: isReturningUser
        });
      } catch (error) {
        const message = error instanceof Error ? error.message : String(error);
        logError("[TIME-TRACKING] [" + page + "] Error: " + message);
      }
    }
  }, [isReturningUser, carleadHash, stepsTimeTracking, hostName, isEnabled, pageType, logError, page]);
}
export function useCarleadTimeTracking(_ref2) {
  let {
    page
  } = _ref2;
  const {
    cookies
  } = useCookie();
  useTimeTracking({
    page,
    pageType: 'step',
    carleadHash: cookies.wkdaLead
  });
}